<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <p style="min-height:200px; margin-top:200px; font-size:2em;">
          {{ msg }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        msg: 'Страница не найдена'
      }
    },
    components: {
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/parts/404page.vue